import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

const DATEPICKER_CONFIG: Partial<BsDatepickerConfig> = {
  dateInputFormat: 'DD.MM.YYYY',
  isAnimated: true,
  containerClass: 'theme-orange',
  showWeekNumbers: false,
  adaptivePosition: true,
};

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), DATEPICKER_CONFIG);
}


